module.exports = __webpack_public_path__ + "static/img/vr3.f0edad34.png";